module.exports = __webpack_public_path__ + "static/media/telien.e19b76d7.svg";